<template>
  <path
    d="M17.66 8.0002L12.71 3.0602C12.32 2.6702 11.69 2.6702 11.3 3.0602L6.34 8.0002C4.78 9.5602 4 11.6402 4 13.6402C4 15.6402 4.78 17.7502 6.34 19.3102C7.9 20.8702 9.95 21.6602 12 21.6602C14.05 21.6602 16.1 20.8702 17.66 19.3102C19.22 17.7502 20 15.6402 20 13.6402C20 11.6402 19.22 9.5602 17.66 8.0002ZM6 14.0002C6.01 12.0002 6.62 10.7302 7.76 9.6002L12 5.2702L16.24 9.6502C17.38 10.7702 17.99 12.0002 18 14.0002H6Z"
  />
</template>
